<template>
  <div style="min-height: 92vh">
    <div>
      <ModuleHeader>Usuarios de Agencia</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="data_usuarios"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Agregar Usuario">
      <addform
        :key="formKey"
        @toggle="toggleModal"
        @successData="successData"
        :hoteles="hoteles"
      ></addform>
    </modal>

    <modal v-model="showModalEdit" :showFooter="false" title="editar Usuario">
      <editform
        :key="formKey"
        :editData="editData"
        @toggle="showModalEdit = false"
        @successData="successDataEdit"
        :hoteles="hoteles"
      ></editform>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../MainComponents/modal.vue";
import addform from "../Afiliados/addUsuarios.vue";
import editform from "../Afiliados/editUsuario.vue";

import uvDataTable from "../MainComponents/DataTable.vue";

export default {
  name: "hoteles",
  components: {
    modal,
    addform,
    uvDataTable,
    editform,
  },
  props: [],
  data() {
    return {
      editData: {},
      showModalEdit: false,
      showModal: false,
      formKey: 0,
      hoteles: [],
      usuarios: [],
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Usuarios",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar Administradores",
            icon: "lni lni-plus",
            buttonId: "addUser",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editUser",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteUser",
            require: true,
          },
        ],
        fields: [
          {
            text: "Codigo de agencia",
            value: "codigoHotel",
          },
          {
            text: "Usuario",
            value: "usuario",
          },
          {
            text: "Login User",
            value: "login",
          },
          {
            text: "Agencia",
            value: "hotel",
            canBeFiltered: true,
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addUser") {
        this.toggleModal(true);
      }

      if (buttonId == "editUser") {
        this.formKey++;
        this.showModalEdit = true;
        this.editData = this.getUserById(idSelected[0]);
      }
      if (buttonId == "deleteUser") {
        this.deleteUser(idSelected[0]);
      }
    },
    async deleteUser(id) {
      this.$swal({
        title: "¿Deseas eliminar este Usuario?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { uid: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-eliminarUsuarioMayorista", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Usuario elimando",
              "El usuario se elimino correctamente",
              "success"
            );
            this.getUsers();
            this.$emit("changeIndex");
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    getUserById(code) {
      let itemIndex = this.$_.findIndex(this.data_usuarios, { id: code });
      if (itemIndex >= 0) {
        return this.data_usuarios[itemIndex];
      }

      return false;
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Mayoristas/Coleccion"
        );
      this.hoteles = [];
      let arrayHoteles = Object.entries(snapshot.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },

    successData(data, data_hotel) {
      let dataUser = {
        hotelId: data_hotel.id,
        hotelCode: data_hotel.Codigo,
        username: data.username,
        password: data.password,
        name: data.nombre,
        URLAdmin: data_hotel.URLAdmin,
      };
      this.saveHotel(dataUser);
    },
    successDataEdit(data) {
      let datos = {
        userName: data.username,
        displayName: data.nombre,
        uid: data.id,
      };
      this.$pgsHelper.log(datos);
      this.$swal({
        title: "Deseas editar el usuario",
        text: "El usuario se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-actualizarUsuarioMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Usuario Guardado",
              "El usuario se almaceno correctamente",
              "success"
            );

            this.formKey++;
            this.showModalEdit = true;
            this.getUsers();
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    saveHotel(data) {
      this.$swal({
        title: "Deseas guardar el usuario administrador de la agencia?",
        text: "El usuario se guardara con los datos especificados",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-crearAdminMayorista", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Usuario Guardado",
              "El usuario se almaceno correctamente",
              "success"
            );

            this.showModal = false;
            this.formKey++;
            this.getUsers();
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getUsers() {
      const database = this.$store.getters.getFirebaseApp.database;
      let user = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Mayoristas/Usuarios",
        [database.orderByChild("EsAdmin"), database.equalTo(true)]
      );

      let new_users = [];
      if (user.exists()) {
        let us = {};
        let result = Object.entries(user.val());
        result.forEach((usu) => {
          /*us  =   Object.entries(element[1]);
                new_users.push({id:us[0][0],...us[1]});*/
          //let users = Object.entries(element[1])
          /*users.forEach((usu)=>{*/
          let userData = { id: usu[0], ...usu[1] };
          this.$pgsHelper.log(userData);
          new_users.push(userData);
          /*})*/
        });
        //result[1]  =   Object.entries(result[1]);

        this.usuarios = new_users;
      } else {
        console.log("No existen usuarios");
      }

      this.$pgsHelper.log(this.usuarios);
    },
    getHotelinfo(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { Codigo: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    getUserName(fullUser) {
      this.$pgsHelper.log(fullUser);
      let dash = fullUser.split("_");
      let at = dash[1].split("@");
      return at[0];
    },
  },
  computed: {
    tipoUsuario() {
      return this.$route.params.user.tokenResult.claims.Type;
    },
    data_usuarios() {
      let data = [];
      this.usuarios.forEach((element) => {
        let user = {
          codigoHotel: element.MCode,
          usuario: element.Correo,
          id: element.id,
          login: this.getUserName(element.Correo.toString()),
          hotel: this.getHotelinfo(element.MCode)
            ? this.getHotelinfo(element.MCode).Nombre
            : "La agencia no existe",
        };
        data.push(user);
      });

      return data;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.getHoteles();
    this.getUsers();
  },
};
</script>
